import React from "react";

const sizeClasses = {
  txtInterMedium20WhiteA700dd: "font-inter font-medium",
  txtInterRegular16BlueA700: "font-inter font-normal",
  txtInterRegular20: "font-inter font-normal",
  txtInterRegular12Gray90001: "font-inter font-normal",
  txtInterRegular12Gray90002: "font-inter font-normal",
  txtInterRegular16WhiteA700dd: "font-inter font-normal",
  txtInterRegular12Gray900dd: "font-inter font-normal",
  txtInterRegular14WhiteA700dd: "font-inter font-normal",
  txtInterMedium14: "font-inter font-medium",
  txtInterRegular16Deeppurple90001: "font-inter font-normal",
  txtInterMedium20: "font-inter font-medium",
  txtInterRegular12Black90099: "font-inter font-normal",
  txtInterRegular24Black900dd: "font-inter font-normal",
  txtInterRegular12Black900dd: "font-inter font-normal",
  txtInterRegular11: "font-inter font-normal",
  txtInterRegular12: "font-inter font-normal",
  txtInterRegular24: "font-inter font-normal",
  txtInterRegular14: "font-inter font-normal",
  txtInterRegular48: "font-inter font-normal",
  txtInterRegular16: "font-inter font-normal",
  txtUrbanistRegular14: "font-normal font-urbanist",
  txtInterRegular16Black90099: "font-inter font-normal",
};

const Text = ({ children, className = "", size, as, ...restProps }) => {
  const Component = as || "p";

  return (
    <Component
      className={`text-left ${className} ${size && sizeClasses[size]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
